class GeolocationOrbeCustom {
  constructor() {
    this.targetSelector = '#custom__md-footer-selector-block';
    this.initialized = false;
    this.observer = null;
    this.lastKeyPressed = '';
    this.lastKeyTime = 0;
    this.currentLetterIndex = 0;
    this.keyRepeatTimeout = 1000;
    
    this.init();
  }

  init() {
    const existingElement = document.querySelector(this.targetSelector);
    if (existingElement) {
      this.handleElementFound(existingElement);
      return;
    }

    this.setupObserver();
  }

  setupObserver() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches && node.matches(this.targetSelector)) {
                this.handleElementFound(node);
                return;
              }
              
              const targetElement = node.querySelector && node.querySelector(this.targetSelector);
              if (targetElement) {
                this.handleElementFound(targetElement);
                return;
              }
            }
          });
        }
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleElementFound(element) {
    if (this.initialized) return;

    this.initialized = true;

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.initialise(element);
  }

  initialise(element) {
    this.setupListeners(element);
  }

  setupListeners(element) {
    document.addEventListener('keydown', (event) => {
      this.setupKeyboardNavigation(element, event);
    });
  }

  setupKeyboardNavigation(element, event) {
    const list = document.querySelector('#orbeCountryList');
  
    if (!list) return;

    if (list.getAttribute('hidden') !== 'true' && event.key.length === 1 && event.key.match(/[a-zA-Z]/)) {
      this.scrollToLetter(list, event.key.toLowerCase());
    }
  }

  scrollToLetter(list, letter) {
    const currentTime = Date.now();
    const isSameKey = this.lastKeyPressed === letter;
    const isWithinTimeout = currentTime - this.lastKeyTime < this.keyRepeatTimeout;
    
    if (!isSameKey || !isWithinTimeout) {
      this.currentLetterIndex = 0;
    } else {
      this.currentLetterIndex++;
    }
    
    this.lastKeyPressed = letter;
    this.lastKeyTime = currentTime;
    
    const items = list.querySelectorAll('li');
    const matchingItems = [];
    
    for (const item of items) {
      const textElement = item.querySelector('.md-form__select__span');
      if (textElement) {
        const text = textElement.textContent.trim().toLowerCase();
        if (text.startsWith(letter)) {
          matchingItems.push(item);
        }
      }
    }
    
    if (matchingItems.length > 0) {
      if (this.currentLetterIndex >= matchingItems.length) {
        this.currentLetterIndex = 0;
      }
      
      const targetItem = matchingItems[this.currentLetterIndex];
      targetItem.scrollIntoView();
      targetItem.querySelector('a').focus();
    }
  }
}

const initialiseWhenReady = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new GeolocationOrbeCustom();
    });
  } else {
    new GeolocationOrbeCustom();
  }
};

initialiseWhenReady();